var map = {
	"./de_DE.json": 977,
	"./en_AU.json": 978,
	"./en_CA.json": 979,
	"./en_GB.json": 980,
	"./es_AR.json": 981,
	"./es_ES.json": 982,
	"./es_MX.json": 983,
	"./fr_CA.json": 984,
	"./fr_FR.json": 985,
	"./it_IT.json": 986,
	"./nl_NL.json": 987,
	"./pt_BR.json": 988,
	"./pt_PT.json": 989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 976;